import React, { useEffect, useState } from 'react'
import './App.css'
import { useLocation } from 'react-router-dom'
import Header from './components/layout/Header'
import { Footer } from './components/layout/Footer'
import { Layout } from './components/layout/Layout'
import { saveLocalStorage } from './utils/common'
import useUserStore from './store/useUserStore'
import { WelcomeModal } from 'components/WelcomeModal'
import { HomePopup } from 'components/popup/HomePopup'
import EventTracker from 'components/EventTracker'
import { GlobalProviders } from './components/GlobalProviders'
import { AppRouter } from './components/AppRouter'
import { AnalyticsProvider } from './components/AnalyticsProvider'
import { AuthProvider } from './components/AuthProvider'
import './i18n'

const ScrollToTop = () => {
  const { pathname } = useLocation()
  useEffect(() => {
    window.scrollTo(0, 0)
  }, [pathname])

  return null
}

function App() {
  const userInfo = useUserStore((state) => state.userInfo)
  const location = useLocation()
  const { pathname } = useLocation()
  const params = new URLSearchParams(location.search)

  const utm_source = params.get('utm_source')
  const utm_campaign = params.get('utm_campaign')
  const affiliate_source = params.get('affiliate_source')
  const affiliate_campaign = params.get('affiliate_campaign')
  const invite_code = params.get('invite_code')
  const userType = params.get('userType')
  const [isWelcomeModal, setWelcomeModal] = useState<boolean>(
    userType === 'true' ? true : false
  )

  if (utm_source) {
    saveLocalStorage('utm_source', utm_source)
    saveLocalStorage('utm_campaign', utm_campaign)
  }
  if (affiliate_source) {
    saveLocalStorage('affiliate_source', affiliate_source)
    saveLocalStorage('affiliate_campaign', affiliate_campaign)
  }
  if (invite_code) {
    saveLocalStorage('invite_code', invite_code)
  }
  return (
    <GlobalProviders>
      <AnalyticsProvider userType={userType} />
      <AuthProvider>
        <ScrollToTop />
        <Header />
        <EventTracker />
        <Layout>
          <AppRouter />
          <WelcomeModal
            userInfo={userInfo}
            isWelcomeModal={isWelcomeModal}
            setWelcomeModal={setWelcomeModal}
          />
          <HomePopup />
        </Layout>
        <Footer />
      </AuthProvider>
    </GlobalProviders>
  )
}

export default App
